var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletePopupIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7227 0C28.4567 0 29.8672 1.43521 29.8672 3.2002V7.2002H36.1543C37.0237 7.2002 37.7265 7.91487 37.7266 8.7998V10.4004C37.7263 10.62 37.5498 10.7996 37.334 10.7998H34.3662L33.1533 36.9502C33.0745 38.6548 31.6894 39.9998 30.0146 40H7.71289C6.03324 39.9998 4.65206 38.6598 4.57324 36.9502L3.36035 10.7998H0.393555C0.177772 10.7996 0.000249943 10.62 0 10.4004V8.7998C6.91148e-05 7.91503 0.703041 7.20044 1.57227 7.2002H7.85938V3.2002C7.85938 1.43536 9.27007 0.000250453 11.0039 0H26.7227ZM8.09082 36.3994H29.6357L30.8252 10.7998H6.90234L8.09082 36.3994ZM15.5059 15.3262C16.0581 15.3262 16.5058 15.7739 16.5059 16.3262V32.0107C16.5056 32.5628 16.058 33.0107 15.5059 33.0107H13.9697C13.4176 33.0107 12.97 32.5628 12.9697 32.0107V16.3262C12.9697 15.7739 13.4175 15.3262 13.9697 15.3262H15.5059ZM23.7588 15.3262C24.311 15.3262 24.7588 15.7739 24.7588 16.3262V32.0107C24.7585 32.5628 24.3109 33.0107 23.7588 33.0107H22.2217C21.6696 33.0106 21.2219 32.5628 21.2217 32.0107V16.3262C21.2217 15.774 21.6695 15.3263 22.2217 15.3262H23.7588ZM11.3965 7.2002H26.3301V3.59961H11.3965V7.2002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePopupIcon);
export default __webpack_public_path__ + "static/media/delete_popup_icon.401113c452a0f5c928810b6e30e99e64.svg";
export { ForwardRef as ReactComponent };